module.exports = __webpack_public_path__ + "img/pdf.7d08afcf.svg";